import { render, staticRenderFns } from "./GameRule.vue?vue&type=template&id=00f4675b&scoped=true"
import script from "./GameRule.vue?vue&type=script&lang=js"
export * from "./GameRule.vue?vue&type=script&lang=js"
import style0 from "./GameRule.vue?vue&type=style&index=0&id=00f4675b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4675b",
  null
  
)

export default component.exports